<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="col-md-8 offset-md-2">
            <h5 class="card-title center">Agregar Modulo</h5>
            <form>
              <div class="form-group row">
                <label for="inputModuleName" class="col-sm-2 col-form-label">Nombre</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="inputModuleName" v-model="input.moduleName">
                </div>
              </div>
              <div class="form-group row">
                <label for="inputModuleLabel" class="col-sm-2 col-form-label">Etiqueta</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="inputModuleLabel" v-model="input.moduleLabel">
                </div>
              </div>
              <div class="form-group row">
                <label for="inputModuleDescription" class="col-sm-2 col-form-label">Descripcion</label>
                <div class="col-sm-10">
                  <textarea class="form-control" id="inputModuleDescription" rows="3" v-model="input.moduleDescription"></textarea>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-6 offset-md-3">
            <div class="form-group row">
                <div class="col-sm-12 mt-5">
                  <button type="button" class="btn btn-primary btn-block" @click="registerNewModule">Registrar</button>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
export default {
  mixins: [formatData],
  data () {
    return {
      input: {
        moduleName: '',
        moduleLabel: '',
        moduleDescription: ''
      }
    }
  },
  methods: {
    async registerNewModule () {
      try {
        const request = {
          function: 'addModule',
          ...this.input
        }
        const params = await this.toFormData(request)
        const response = await axiosAdelaService.post('/', params)
        if (response.status === 200) {
          this.$toastedPush({
            message: 'Se agrego el nuevo modulo.',
            type: 'success'
          })
          this.$router.push({ name: 'modules' })
        }
      } catch (error) {
        this.showError('No se pudo agregar el modulo, intentalo mas tarde')
      }
    }
  }
}
</script>

<style>

</style>
